import { render, staticRenderFns } from "./templateDetail.vue?vue&type=template&id=b99d76c4&scoped=true&"
import script from "./templateDetail.vue?vue&type=script&lang=js&"
export * from "./templateDetail.vue?vue&type=script&lang=js&"
import style0 from "./templateDetail.vue?vue&type=style&index=0&id=b99d76c4&scoped=true&lang=scss&"
import style1 from "./templateDetail.vue?vue&type=style&index=1&id=b99d76c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99d76c4",
  null
  
)

export default component.exports